module.exports = __webpack_public_path__ + "img/81.7d8b3090.jpg";